import React from 'react'

const Trust = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/trust',
  ...props
}) => (
  <svg height='75' width='121' viewBox='0 0 121 75' style={style} {...props}>
    <g
      strokeWidth='2.25'
      fill='none'
      fillRule='evenodd'
      strokeLinecap='round'
      strokeLinejoin='round'>
      <path
        d='M60.593 1.241h-.084s12.349 11.587 25.424 11.587c0 0 2.906 59.379-25.424 59.379s-25.425-59.38-25.425-59.38c13.076 0 25.425-11.586 25.425-11.586h-.085'
        stroke={primaryColor} />
      <path
        stroke={secondaryColor}
        d='M70.902 30.569L57.1 42.879l-5.085-5.793' />
      <path
        d='M60.5 1.966v28.538M60.5 48.495v23.712M84.472 35.75h-9.985M46.698 36h-10.17'
        stroke={primaryColor} />
    </g>
  </svg>
)

export default Trust
